import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router';
import AppLayout from '../components/layout/AppLayout';
import RequireAuth from './RequireAuth';
import { RouteShimmer } from '../components/shared/shimmer';
import SignIn from '../pages/SignIn';
const PageNotFound = lazy(() => import('../pages/PageNotFound'));
const Epms = lazy(() => import('../pages/Epms/Epms'));
const EpmsLogs = lazy(() => import('../pages/Epms/EpmsLogs'));
const EpmsLogsDetail = lazy(() => import('../pages/Epms/EpmsLogsDetail'));
const Dashboard = lazy(() => import('../pages/Dashboard/Dashboard'));
const AP_Prohance = lazy(() => import('../pages/AutoProvisioning/Prohance/AP_Prohance'));
const AP_ProhanceCondition = lazy(
  () => import('../pages/AutoProvisioning/Prohance/AP_ProhanceCondition')
);
const AP_ManageJobs = lazy(() => import('../pages/AutoProvisioning/ManageJobs/AP_ManageJobs'));
const AP_Falcon = lazy(() => import('../pages/AutoProvisioning/Falcon/AP_Falcon'));
const AP_FalconCondition = lazy(
  () => import('../pages/AutoProvisioning/Falcon/AP_FalconCondition')
);
const FalconLogs = lazy(() => import('../pages/AutoProvisioning/Falcon/FalconLogs'));
const FalconLogsDetail = lazy(() => import('../pages/AutoProvisioning/Falcon/FalconLogsDetails'));
const ProjectOverview = lazy(() => import('../pages/Projects/ProjectOverview'));
const ProjectDetails = lazy(() => import('../pages/Projects/ProjectDetails'));
const NewConnection = lazy(() => import('../pages/Projects/NewConnection'));
const ConnectForm = lazy(() => import('../pages/Projects/ConnectForm'));
const NewJob = lazy(() => import('../pages/Projects/NewJob'));
const CronJobDetails = lazy(() => import('../pages/Projects/CronJobDetails'));
const LogDetailsDrawer = lazy(() => import('../pages/Projects/LogDetailsDrawer'));
const AP_MaestroAutoProvisioning = lazy(
  () => import('../pages/AutoProvisioning/Maestro/AP_MaestroAutoProvisioning')
);
const AP_MaestroCondition = lazy(
  () => import('../pages/AutoProvisioning/Maestro/AP_MaestroCondition')
);

const SuspenseFallback: React.FC = () => <RouteShimmer />;

const ProtectedRoutes: React.FC = () => {
  const user = localStorage.getItem('authToken');
  return user ? <Outlet /> : <Navigate replace to="/login" />;
};

const PublicRoutes: React.FC = () => {
  return (
    <Suspense fallback={<SuspenseFallback />}>
      <Routes>
        <Route path="/" element={<ProtectedRoutes />}>
          <Route path="/" element={<AppLayout />}>
            {/* Default route */}
            <Route index element={<Epms />} />

            {/* Employee Master */}
            <Route path="employee-master">
              <Route element={<RequireAuth allowedRoles={['EMPLOYEE_MASTER_DASHBOARD1']} />}>
                <Route path="dashboard" element={<Dashboard />} />
              </Route>
              <Route
                element={
                  <RequireAuth allowedRoles={['EMPLOYEE_MASTER_SNAPSHOT', 'AD_MANAGER_SNAPSHOT']} />
                }
              >
                <Route path="snapshot" element={<Epms />} />
              </Route>
              <Route
                element={
                  <RequireAuth
                    allowedRoles={['EMPLOYEE_MASTER_SNAPSHOT_LOGS', 'AD_MANAGER_ACCESS_LOGS']}
                  />
                }
              >
                <Route path="logs" element={<EpmsLogs />} />
                <Route path="logsDetail" element={<EpmsLogsDetail />} />
              </Route>
            </Route>

            {/* Auto Provisioning */}
            <Route path="auto-provisioning">
              <Route element={<RequireAuth allowedRoles={['AP_PROHANCE']} />}>
                <Route path="prohance" element={<AP_Prohance />} />
                <Route path="prohance/:id" element={<AP_ProhanceCondition />} />
              </Route>
              <Route element={<RequireAuth allowedRoles={['AP_GLOBAL_JOB']} />}>
                <Route path="manage-jobs" element={<AP_ManageJobs />} />
              </Route>
              <Route element={<RequireAuth allowedRoles={['AP_PIXIE']} />}>
                <Route path="configure" element={<AP_Falcon />} />
                <Route path="configure/:id" element={<AP_FalconCondition />} />
              </Route>
            </Route>

            {/* Maestro */}
            <Route path="maestro">
              <Route element={<RequireAuth allowedRoles={['AP_PROHANCE']} />}>
                <Route path="auto-provisioning" element={<AP_MaestroAutoProvisioning />} />
                <Route path="auto-provisioning/:id" element={<AP_MaestroCondition />} />
              </Route>
            </Route>

            {/* Falcon Logs */}
            <Route path="falcon">
              <Route element={<RequireAuth allowedRoles={['FALCON_LOGS']} />}>
                <Route path="logs" element={<FalconLogs />} />
                <Route path="logsDetail" element={<FalconLogsDetail />} />
              </Route>
            </Route>

            {/* Projects */}
            <Route element={<RequireAuth allowedRoles={['AUTOMATION_PROJECT']} />}>
              <Route path="projects">
                <Route path="overview" element={<ProjectOverview />} />
                <Route path=":title" element={<ProjectDetails />} />
                <Route path=":title/:jobName/editJob" element={<NewJob />} />
                <Route path=":title/:jobName" element={<CronJobDetails />} />
                <Route path=":title/:jobName/:logDetails" element={<LogDetailsDrawer />} />
                <Route path=":title/addconnection" element={<NewConnection />} />
                <Route path="addconnection/:appName" element={<ConnectForm />} />
                <Route path=":title/addJob" element={<NewJob />} />
              </Route>
            </Route>
          </Route>
        </Route>

        {/* Public routes */}
        <Route path="/login" element={<SignIn />} />
        {/* <Route path="/signin" element={<SignIn />} /> */}
        <Route path="/unauthorized" element={<PageNotFound />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
};

export default PublicRoutes;
